import { Avatar,Stack } from "@mui/material"
import Facebook from '../../../assets/facebook.svg'
import Twitter from '../../../assets/twitter.svg'
import Linkedin from '../../../assets/linkedin.svg'

const FooterLinks = () => {

   return ( <Stack alignItems="center" spacing="24px" mt="16px" direction="row">
        <Avatar sx={{ width: '29px', height: '29px' }} src={Facebook}></Avatar>
        <Avatar sx={{ width: '27px', height: '23px' }} src={Twitter}></Avatar>
        <Avatar sx={{ width: '29px', height: '29px' }} src={Linkedin}></Avatar>
     </Stack>
   )
}

export default FooterLinks;
